import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import close from '../../assets/img/icons/close.svg'
import { Form, Modal, Button } from 'react-bootstrap';
import Autocomplete from 'react-google-autocomplete';
import locationbg from '../../assets/img/locationbg.svg';
import ls from "local-storage";
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";    

const API_KEY = "AIzaSyA5h0ra_DpRn2ii7bN0kQb0yFfmZgQg-XE";

class Location extends Component {

    constructor(props) {
        super(props);
        this.onSubmitlocationsearch = this.onSubmitlocationsearch.bind(this);
        this.state = {
            errors: {},
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            place: null,
            lat_search: null,
            lon_search: null,
            clickOnce: 0,
        };
    }

    onSubmitlocationsearch(e){
        e.preventDefault();
        let clickOnce = this.state.clickOnce;

        if(localStorage.getItem('session_userid') !== null && localStorage.getItem('session_userid') !== '') {
            if(this.state.lat === "" || this.state.lat === null || this.state.lon === "" || this.state.place=== "" || this.state.place=== null){
                this.setState({ nolocation: 'Location cannot be empty' });
                setTimeout(() => {
                    this.setState({
                        nolocation: ''
                    });
                }, 2000); 
            } else if(typeof(this.state.lat_search) === 'undefined' || typeof(this.state.lon_search) === 'undefined') {
                this.setState({ nolocation: 'Please select the location from dropdown' });
                setTimeout(() => {
                    this.setState({
                        nolocation: ''
                    });
                }, 2000);
            } else {
                var location = new FormData();
                if(this.state.place){
                    var address=this.state.place;
                    var value=address.split(","); 
                    var count=value.length; 
                    var country=value[count-1]; 
                    var state=value[count-2]; 
                    var city=value[count-3];
                    if(city != null || typeof(city) !== 'undefined'){
                        location.append('place', city+", "+state+", "+country);
                        this.setState({
                            loc: city+", "+state+", "+country
                        });
                    }else{
                        location.append('place', state+", "+country);
                        this.setState({
                            loc: state+", "+country
                        });
                    }
                }
                location.append('lat', this.state.lat_search);
                location.append('lon', this.state.lon_search);
                location.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                location.append('language', this.state.langKey);
                axios({
                    method: 'post',
                    url: this.state.api_url+'websetprofile',
                    data: location,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    const status = res.data.status;
                    if(status === "true"){
                        localStorage.setItem('place', this.state.loc);
                        localStorage.setItem('lat', this.state.lat_search);
                        localStorage.setItem('lon', this.state.lon_search);
                        window.location.reload();
                    }
                });
            }
        } else {
            if(this.state.place === null && this.state.lat_search === null && this.state.lon_search === null) {
                this.setState({ nolocation: 'Location cannot be empty' });
                setTimeout(() => {
                    this.setState({
                        nolocation: ''
                    });
                }, 2000);
            } else { 
                if(clickOnce === 0) {  
                    this.setState({
                        clickOnce: 1
                    }); 
                }
                var signup = new FormData();
                signup.set('check', localStorage.getItem('seleted_passion'));
                signup.set('languages', localStorage.getItem('selected_language'));
                signup.set('relogions', localStorage.getItem('seleted_religion'));
                signup.set('biography', localStorage.getItem('biography'));
                signup.set('name', localStorage.getItem('name'));
                signup.set('email', localStorage.getItem('email'));
                signup.set('password', localStorage.getItem('password'));
                signup.set('dob', localStorage.getItem('dob'));
                signup.set('phone', localStorage.getItem('phone'));
                signup.set('faceId', localStorage.getItem('faceId'));
                signup.set('faceImage', localStorage.getItem('faceImage'));
                signup.set('age', localStorage.getItem('age'));
                signup.set('gender', localStorage.getItem('gender'));
                signup.set('image_name', (localStorage.getItem('image_name') !== null) ? localStorage.getItem('image_name') : '');
                signup.set('image_url', (localStorage.getItem('image_url') !== null) ? localStorage.getItem('image_url') : '');
                signup.set('peopleforid', localStorage.getItem('peopleforid'));
                signup.set('lat', this.state.lat_search);
                signup.set('lon', this.state.lon_search);
                signup.set('location', this.state.place);
                signup.set('language', this.state.langKey);
                
                axios({
                    method: 'post',
                    url: this.state.api_url+'signupweb',
                    data: signup,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    if(res.data.status !== "true") {
                        this.setState({ nolocation: res.data.message });
                        setTimeout(() => {
                            this.setState({
                                nolocation: ''
                            });
                        }, 2000);
                        this.setState({
                            clickOnce: 0
                        }); 
                    } else {
                        signup.set('check', '');
                        signup.set('languages', '');
                        signup.set('relogions', '');
                        signup.set('name', '');
                        signup.set('email', '');
                        signup.set('password', '');
                        signup.set('dob', '');
                        signup.set('gender', '');
                        signup.set('image_name', '');
                        signup.set('image_url', '');
                        signup.set('peopleforid', '');
                        signup.set('lat', '');
                        signup.set('lon', '');
                        signup.set('location', '');
    
                        var signin = new FormData();
                        signin.set('email', localStorage.getItem('email')); 
                        signin.set('password', localStorage.getItem('password'));
                        signin.set('language', this.state.langKey);
    
                        axios({
                            method: 'post',
                            url: this.state.api_url+'webemaillogin',
                            data: signin,
                            config: { headers: {'Content-Type': 'multipart/form-data' }}
                        }).then(res => {
                            let formIsValid = true;
                            if(res.data.status !== "true"){
                                this.setState({ nolocation: res.data.message });
                                setTimeout(() => {
                                    this.setState({
                                        nolocation: ''
                                    });
                                }, 2000);
                                this.setState({
                                    clickOnce: 0
                                });
                            } else {
                                var loginstatus = new FormData();
                                loginstatus.set('user_id', res.data.peoples.user_id);
                                loginstatus.set('status', '1');
                                loginstatus.set('language', this.state.langKey);  
                                axios({  
                                    method: 'post',
                                    url: this.state.api_url+'webonlinestatus',
                                    data: loginstatus,
                                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                                })
                                let d = new Date();
                                const cookies = new Cookies(); 
                                d.setTime(d.getTime() + (12*60*60*1000));   
                                cookies.set('onboarded', 'true', {path: "/", expires: d});
                                        
                                localStorage.setItem('session_token',JSON.stringify(res.data.peoples.token));
                                localStorage.setItem('session_userid',JSON.stringify(res.data.peoples.user_id));
                                sessionStorage.setItem('loggedin', 'true');
                                cookies.set('fbemail', '');
                                cookies.set('fbid', '');
                                cookies.set('fbname', '');
                                cookies.set('fbpic', '');
                                localStorage.setItem('place', this.state.place);
                                localStorage.setItem('lat', this.state.lat_search);
                                localStorage.setItem('lon', this.state.lon_search);   
                                this.props.history.push('/find')
                            }
                            return formIsValid;
                        });
                    }
                });
            }
        }
    }

    render() {
        return (
            <div className="">
                <Modal className="modal_div location_modal" show={this.props.showModal} centered>
                    <Form className='' onSubmit={this.onSubmitlocationsearch}>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Change Location">Change Location</Trans></Modal.Title>
                            {(localStorage.getItem('session_userid') !== null && localStorage.getItem('session_userid') !== '') ?
                            <Button className="close" onClick={this.props.handleClose}>
                                <img src={close} alt="img" />
                            </Button> : ''}
                        </Modal.Header>
                        <Modal.Body>
                            <div className='location_modal_img'>
                                <img src={locationbg} alt="img" />
                            </div>
                            <Form.Group controlId="formPlaintextEmail" className="location_form welcome_form">
                                <div >
                                    <Autocomplete
                                        apiKey={API_KEY}
                                        onPlaceSelected={(place) => {
                                            this.setState({ place: place.formatted_address, lat_search: place.geometry.location.lat() , lon_search: place.geometry.location.lng() })
                                        }}
                                        types={['(regions)']}
                                        style={{width: '100%'}}
                                    />
                                </div>
                            </Form.Group>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "25px" }}>{this.state.nolocation}</div>
                        <Modal.Footer className="forgot_button_plr location_footer">
                            {(localStorage.getItem('session_userid') !== null && localStorage.getItem('session_userid') !== '') 
                            ? <Button type="submit" className='button_primary'><Trans i18nKey="Change Location">Change Location</Trans></Button>
                            : <Button type="submit" className='button_primary'><Trans i18nKey="Join with Kabadate">Join with Kabadate</Trans></Button> 
                              }
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Location);
